import React from 'react';
import TextArea from 'shared/app/components/text-area/index.js';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

const MESSAGE_COUNTER_ID = 'messageCounter';

const InputMessage = ({ message, maxMessageLength, setMessageValue }) => {
  return (
    <TextArea
      {...message.input}
      data-e2e="recipientMessage"
      floatLabelText={<FormattedMessage {...messages.messageLabel} />}
      id="message"
      maxLength={maxMessageLength}
      messageCounterId={MESSAGE_COUNTER_ID}
      onFocus={(e) => {
        setMessageValue(e.target.value);
      }}
    />
  );
};

export default InputMessage;
